document.addEventListener('DOMContentLoaded', () => {
    let forms = document.querySelectorAll('form.cms_survey_request');

    if (forms.length !== 0) {
        let input_selector = 'input[name="cms_survey_request[surveyor_decision]"]',
            form_selector,
            selector,
            survey_request_decisions,
            survey_request_decision_selected,
            approval_group_form,
            objection_group_form,
            to_be_displayed,
            to_be_hidden,
            index,
            len;

        forms.forEach(function (form) {
            form_selector = `form#${form.id}`
            selector = `${form_selector} ${input_selector}`;

            survey_request_decisions = form.querySelectorAll(input_selector);

            if (survey_request_decisions.length !== 0) {
                survey_request_decision_selected = null;

                for (index = 0, len = survey_request_decisions.length; index < len; ++index) {
                    if (survey_request_decisions[index].checked) {
                        survey_request_decision_selected = survey_request_decisions[index];
                        break;
                    }
                }


                if (survey_request_decision_selected !== null) {
                    approval_group_form = form.querySelectorAll('.approval_attributes_container');
                    objection_group_form = form.querySelectorAll('.objection_attributes_container');

                    switch (survey_request_decision_selected.value) {
                        case 'approved':
                            approval_group_form.forEach(function (e) {
                                e.classList.remove('hidden');
                            });

                            break;

                        case 'objected':
                            objection_group_form.forEach(function (e) {
                                e.classList.remove('hidden');
                            });

                            break;

                        default:
                            break;
                    }
                }

                $(selector).click(function () {
                    form = this.closest('form');
                    approval_group_form = form.querySelectorAll('.approval_attributes_container');
                    objection_group_form = form.querySelectorAll('.objection_attributes_container');

                    switch (this.value) {
                        case 'approved':
                            to_be_displayed = approval_group_form;
                            to_be_hidden = objection_group_form;
                            break;

                        case 'objected':
                            to_be_displayed = objection_group_form;
                            to_be_hidden = approval_group_form;
                            break;

                        default:
                            break;
                    }

                    to_be_displayed.forEach(function (e) {
                        e.classList.remove('hidden');
                    });

                    to_be_hidden.forEach(function (e) {
                        e.classList.add('hidden');
                    });
                });
            }
        });
    }
});
